export const PostPurchasePromoDesignPhase2AbTestVariantBasicTemplate = 'basic template';
export const PostPurchasePromoDesignPhase2AbTestVariant3StepTemplate = '3-step template';
export const PostPurchasePromoDesignPhase2AbTestVariantVideoTemplate = 'video template';
